import { cooKeys, removeCookie, setCookie } from "goi_common";
import { useRouter } from "next/router";

export const useCheckGoogleSA = () => {
  const router = useRouter();

  const setIsCheckSearchAdInCookie = () => {
    /** 광고면 1시간 동안만 유지되는 쿠키 세팅 만일 한번이라도 광고도 포함시키려면 제거  */

    const utmTermValue = router?.query?.utm_term;
    const gclidValue = router?.query?.gclid;

    /** 테스트해봐야함 */
    const refererValue =
      document?.referrer?.includes("syndicatedsearch.goog") ||
      document?.referrer?.includes("youtube") ||
      document?.referrer?.includes("googlequicksearchbox");

    if (utmTermValue && gclidValue && !refererValue) {
      setCookie(cooKeys.is_search_ad, "true");
    } else {
      removeCookie(cooKeys.is_search_ad);
    }
  };

  const setIsCheckPageType = () => {
    const PAGE_TYPE_PATHNAME = {
      "/parlor/[id]": "parlor",
      "/crematorium/[id]": "crematorium",
      // "/guidebook/tip/[category]/[index]": "guidebook",
      "/facilities/[id]": "facility",
    };

    console.log(router.pathname);

    const pageTypeValue = PAGE_TYPE_PATHNAME[router.pathname as keyof typeof PAGE_TYPE_PATHNAME];

    if (pageTypeValue) {
      setCookie(cooKeys.session_landing_type, pageTypeValue);
    } else {
      removeCookie(cooKeys.session_landing_type);
    }
  };

  return {
    setIsCheckSearchAdInCookie,
    setIsCheckPageType,
  };
};
